module.exports = "/_next/static/images/loading_07-53f18019a52a4d1b2ed2c638f6f98430.png";